const uniqueDriversReport = {
  table: {
    headers: {
      date: 'תאריך',
      uniqueDrivers: 'נהגים ייחודיים',
    },
    tableDetails: {
      headers: {
        date: 'תאריך',
        uniqueDrivers: 'נהגים ייחודיים',
        driver: 'נהג',
        trips: 'נסיעות',
      },
    },
  },
  actions: {
    export: 'ייצא',
  },
};

export default uniqueDriversReport;
